(() => {
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) return;

  let activeRecognition = null;
  let isListening = false;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-voice-btn]');
    if (!btn) return;

    const form = btn.closest('form[data-voice-search]');
    if (!form) return;

    const input = form.querySelector('input[type="search"]');
    const indicator = form.querySelector('.voice-indicator');
    if (!input) return;

    // 🔁 TOGGLE OFF
    if (isListening && activeRecognition) {
      activeRecognition.stop();
      return;
    }

    const recognition = new SpeechRecognition();
    activeRecognition = recognition;
    isListening = true;

    recognition.lang = document.documentElement.lang || 'en-US';
    recognition.continuous = false;
    recognition.interimResults = true;

    // UI: listening ON
    btn.classList.add('is-listening');
    btn.setAttribute('aria-pressed', 'true');
    indicator?.removeAttribute('hidden');
    indicator && (indicator.textContent = 'Listening…');

    recognition.start();

    recognition.onresult = (event) => {
      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (!event.results[i].isFinal) continue;

        const transcript = event.results[i][0].transcript.trim();
        if (!transcript) return;

        input.value = transcript;
        indicator && (indicator.textContent = 'Searching…');

        recognition.stop();
        form.requestSubmit();
        break;
      }
    };

    const cleanup = () => {
      isListening = false;
      activeRecognition = null;

      btn.classList.remove('is-listening');
      btn.removeAttribute('aria-pressed');
      indicator?.setAttribute('hidden', '');
    };

    recognition.onerror = cleanup;
    recognition.onend = cleanup;
  });
})();
